import React, {useEffect, useState} from "react";
import axios from "axios";
import Loading from "../../icons/Loading";
import dispatch from "../../../components/dispatch";
import RemoveBin from "../../icons/RemoveBin";
import CaretRight from "../../icons/CaretRight";
import {
  ACTION_DISCOUNT_CODE,
  ACTION_REMOVE_ITEM,
  ACTION_UPDATE_CART_ITEMS,
  ON_CART_UPDATE,
  ON_CELLS_PROCESSED,
} from "../../globals";
import ProgressBar from "./ProgressBar";
import openCartPopup from "../../../components/openCartPopup";
import isLoggedIn from "../../../components/isLoggedIn";

const CartPage = () => {

  const [cartUpdating, setCartUpdating] = useState(false);
  const [cartLoading, setCartLoading] = useState(true);
  const [loyaltyLoading, setLoyaltyLoading] = useState(true);
  const [allowanceLoading, setAllowanceLoading] = useState(true);
  const [cart, setCart] = useState(null);
  const [itemsAggregate, setItemsAggregate] = useState(null);
  const [stocksList, setStocksList] = useState({});
  const [discountCode, setDiscountCode] = useState('');
  const [updatedPromoCode, setUpdatedPromoCode] = useState(null);
  const [removing, setRemoving] = useState([]);
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [allowanceData, setAllowanceData] = useState([]);

  const loggedIn = isLoggedIn();

  const bindActions = () => {
    window.addEventListener(ON_CART_UPDATE, (e) => {
      setCart(e.data);
    });
  };

  const applyDiscountCodeEnter = (e) => {
    if (e.keyCode === 13) {
      applyDiscountCode();
    }
  }

  const applyDiscountCode = () => {
    axios
      .post(ACTION_DISCOUNT_CODE, {
        code: discountCode,
      })
      .then((response) => {
        dispatch(ON_CART_UPDATE, response.data);

        if (response.data.discount_code) {
          setUpdatedPromoCode(true);
        } else {
          setUpdatedPromoCode(false);
        }
      });
  }

  const removeItemsByProductId = (id, color) => {
    setCartUpdating(true);
    setRemoving([...removing, `${id}-${color}`]);

    axios.post(ACTION_REMOVE_ITEM, {
      product_id: id,
      color: color
    }).then((response) => {
      // const jsonData = response.data.substring(response.data.indexOf('{'));
      try {
        const data = response.data;
        dispatch(ON_CART_UPDATE, data);
      } catch (err) {
        console.log('Error handling cart update:', err);
      }
      setCartUpdating(false);
    }).catch((error) => {
      console.error('Error removing item:', error);
      setCartUpdating(false);
    });
  };

  const updateAggregations = () => {

    const items = cart.item_records;
    const aggregation = [];

    items.map((item) => {
      let group = aggregation.find((i) => {
        return i.productId === item.product_id
          && i.color === item.color;
      });

      if (!group) {
        group = {
          image: item.image,
          total: 0,
          code: item.product_sku,
          title: item.title,
          quantity: 0,
          productId: item.product_id,
          color: item.color,
          colorId: item.color_id,
          sizes: item.all_sizes,
          items: []
        }
        aggregation.push(group);
      }
      group.total += item.total_f;
      group.quantity += item.quantity;
      group.items.push(item);
    });
    setItemsAggregate(aggregation);
  }


  const updateCart = () => {
    if (Object.keys(stocksList).length) {
      setCartUpdating(true);

      axios.post(ACTION_UPDATE_CART_ITEMS, stocksList)
        .then((response) => {
          const data = response.data;
          dispatch(ON_CART_UPDATE, data);
        })
        .catch((error) => {
          console.error('Failed to update cart:', error);
        })
        .finally(() => {
          setCartUpdating(false);
        });
    }
  };

  const loadLoyaltyData = () => {
    setLoyaltyLoading(true);
    axios.post('cart-api/loyalty-data')
      .then((response) => {
        const data = response.data;
        setLoyaltyData(data);
        setLoyaltyLoading(false);
      });
  }

  const loadAllowanceData = () => {
    setAllowanceLoading(true);
    axios.post('cart-api/allowance-data')
      .then((response) => {
        const data = response.data;
        setAllowanceData(data);
        setAllowanceLoading(false);
      });
  }

  useEffect(() => {
    bindActions();
    if (loggedIn) {
      loadLoyaltyData();
      loadAllowanceData();
    }
  }, []);

  useEffect(() => {
    if (cart) {
      setCartLoading(false);
      updateAggregations();
      setStocksList({});
    }
  }, [cart]);

  if (cartLoading) {
    return <div className="cart">
      <div className="cart__loading">
        <Loading/>
      </div>
    </div>
  }

  return <>
    <div className="cart-page cart-page--desktop">
      <table className="cart-page__main-table">
        <thead>
        <tr>
          <th></th>
          <th>Code</th>
          <th>Description</th>
          <th className="size-title">Qty</th>
          <th>Amount</th>
        </tr>
        </thead>
        <tbody>
        {itemsAggregate.map((group, index) => {
          return <tr key={index}>
            <td>
              <img src={group.image} alt={group.title}/>
            </td>
            <td>
              {group.code}
            </td>
            <td className="cart-page__fixed-sized">
              {group.title}<br/><strong>{group.color}</strong>

              <div className="cart-page__size-table-wrapper">
                <table className="cart-page__size-table">
                  <tr>
                    <td>SIZE</td>
                    {group.sizes.map((size, index) => (
                      <td key={`size_${index}`}>
                        {size.value}
                      </td>
                    ))}
                  </tr>
                  <tr className="cart-page__size-table__qtys">
                    <td>QTY</td>
                    {group.sizes.map((size, index) => {
                      const item = group.items.find((i) => i.size_id === size.id);
                      const key = group.productId + '__' + group.colorId + '__' + size.id;
                      const enteredValueClass = item && item.quantity > 0 ? "cart-page__size-table__entered-qty" : "";
                      return <td key={`size_${index}`} className={enteredValueClass}>
                        <input
                          type={"number"}
                          min={0}
                          placeholder={0}
                          style={{
                            width: '100%',
                            minWidth: 'none'
                          }}
                          disabled={!loggedIn && !cart.enabled_retail_order}
                          onBlur={() => {
                            updateCart();
                          }}
                          onChange={(e) => {
                            let val = parseInt(e.target.value);
                            if (val < 0 || isNaN(val)) {
                              val = 0;
                            }
                            stocksList[key] = val;
                            setStocksList({...stocksList});
                          }}
                          value={key in stocksList ? stocksList[key] : (item ? item.quantity : '')}
                        />
                      </td>
                    })}
                  </tr>
                </table>
              </div>
            </td>
            <td className="cart-page__item__totalQty">
              {group.quantity}
            </td>
            <td class="cart-page__item__price__td">
              <div className="cart-page__item__price">
                {removing.indexOf(`${group.productId}-${group.colorId}`) >= 0 && <>
                  <Loading/>
                </>}
                {removing.indexOf(`${group.productId}-${group.colorId}`) < 0 && <>

                  {(() => {
                    const item = group.items.find((i) => i.color_id === group.colorId);
                    return item?.discounted_total &&
                    cart.is_applied_code &&
                    item.available_for_discount ? (
                      <span style={{color: 'green'}}>
                         {`$${item.discounted_total.toFixed(2)}`}
                    </span>
                    ) : (
                      `$${group.total.toFixed(2)}`
                    );
                  })()}

                  <br/>
                  <div
                    className="cart-page__item__remove"
                    onClick={(e) => {
                      e.preventDefault();
                      removeItemsByProductId(group.productId, group.colorId);
                      return false;
                    }}>
                    <RemoveBin/>
                    Remove
                  </div>
                </>}
              </div>
            </td>
          </tr>
        })}
          <tr class="cart-page__total-row">
            <td colSpan={3}></td>
            <td class="cart-page__total-items">{cart.items} items total.</td>
            <td></td>
          </tr>

        <tr className="cart-page__borderless-row">
          <td colSpan={3}>
            {loggedIn && (
              <>
                {(loyaltyLoading || allowanceLoading) ? (
                  <Loading/>
                ) : (
                  <ProgressBar
                    packages={loyaltyData}
                    sample_allowance={allowanceData}
                    name={cart.account_name}
                  />
                )}
              </>
            )}

          </td>

          <td colSpan={2} style={{borderColor: "white"}} className="cart-page__foot">
            <div className={`cart-page__foot__content ${
              loyaltyData && loyaltyData.length > 0 ? "absoluteContent" : ""
            }`}>

              {cart.is_main_site && <div className="cart-page__foot__promo">
                <div className="cart-page__promocode">
                  <input
                    type={"text"}
                    placeholder={'PROMO CODE'}
                    value={discountCode}
                    onKeyUp={applyDiscountCodeEnter}
                    onChange={(e) => {
                      setDiscountCode(e.target.value)
                    }}
                  />
                  <button
                    className="btn"
                    onClick={applyDiscountCode}
                  >
                    Apply
                  </button>

                </div>
                {updatedPromoCode || cart.is_applied_code ? (
                  <p style={{color: 'green', margin: '10px 0'}}>Code applied</p>
                ) : updatedPromoCode === false ? (
                  <p style={{color: 'red', margin: '10px 0'}}>Invalid code</p>
                ) : null}
              </div>
              }
              <div className="cart-page__subtotal">
                <p>Subtotal (Ex. GST)</p>
                {cart.is_applied_code ? (
                  <p>{cart.discounted_items_total}</p>
                ) : (
                  <p>{cart.items_total}</p>
                )}
              </div>
              <div className="header-cart-popup__btns cart-page__continue">
                <a
                  href={cart.checkout_link}
                  className={`btn btn--black btn--not-bg-icon ${cartUpdating ? 'btn--disabled' : ''}`}
                >
                  {cartUpdating && <Loading/>}
                  {!cartUpdating && <>
                    <span>Continue</span>
                    <div className="cart-page__continue__caret">
                      <CaretRight/>
                    </div>
                  </>}
                </a>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div className="cart-page cart-page--mobile">
      <div className="cart-page__main-table">

        {itemsAggregate.map((group, index) => {
          return <div key={index} className="cart-page__product">
            <div className="cart-page__product-data">
              <img src={group.image} alt={group.title}/>
              <div>
                <span>{group.code}</span>{group.title}<br/><strong>{group.color}</strong>
              </div>
            </div>
            <div className="cart-page__sizes">
              <div className="cart-page__size-table-wrapper">
                <table className="cart-page__size-table">
                  <tr>
                    <td>size</td>
                    {group.sizes.map((size, index) => (
                      <td key={`size_${index}`}>
                        {size.value}
                      </td>
                    ))}
                  </tr>
                  <tr className="cart-page__size-table__qtys">
                    <td>Qty</td>
                    {group.sizes.map((size, index) => {
                      const item = group.items.find((i) => i.size_id === size.id);
                      const key = group.productId + '__' + group.colorId + '__' + size.id;
                      return <td key={`size_${index}`}>
                        <input
                          type={"number"}
                          min={0}
                          style={{
                            width: '100%',
                            minWidth: 'none'
                          }}
                          disabled={!loggedIn && !cart.enabled_retail_order}
                          onBlur={() => {
                            updateCart();
                          }}
                          onChange={(e) => {
                            let val = parseInt(e.target.value);
                            if (val < 0 || isNaN(val)) {
                              val = 0;
                            }
                            const sanitizedValue = val.toString().replace(/^0+/, '0');
                            stocksList[key] = sanitizedValue;
                            setStocksList({...stocksList});
                          }}
                          value={key in stocksList ? stocksList[key] : (item ? item.quantity : 0)}
                        />
                      </td>
                    })}
                  </tr>
                </table>
              </div>
            </div>

            <div className="cart-page__item__totalQty">
              Total Quantity: {group.quantity}
            </div>

            <div className="cart-page__item__price">
              {removing.indexOf(`${group.productId}-${group.colorId}`) >= 0 && <>
                <Loading/>
              </>}
              {removing.indexOf(`${group.productId}-${group.colorId}`) < 0 && <>
                {(() => {
                  const item = group.items.find((i) => i.color_id === group.colorId);
                  return item?.discounted_total &&
                  cart.is_applied_code &&
                  item.available_for_discount ? (
                    <span style={{color: 'green'}}>
                         {`$${item.discounted_total.toFixed(2)}`}
                    </span>
                  ) : (
                    `$${group.total.toFixed(2)}`
                  );
                })()}

                <br/>
                <div
                  className="cart-page__item__remove"
                  onClick={(e) => {
                    e.preventDefault();
                    removeItemsByProductId(group.productId, group.colorId);
                    return false;
                  }}>
                  <RemoveBin/>
                  Remove
                </div>
              </>}
            </div>
          </div>
        })}



        {loggedIn && <>
          {(loyaltyLoading || allowanceLoading)
            ? <Loading/>
            : <ProgressBar
              packages={loyaltyData}
              sample_allowance={allowanceData}
              name={cart.account_name}
            />
          }
        </>}
          <h6 class="cart-page__total-items">{cart.items} items total.</h6>
        {cart.is_main_site && <div>
          <div className="cart-page__promocode">
            <input
              type="text"
              placeholder="PROMO CODE"
              value={discountCode}
              onKeyUp={applyDiscountCodeEnter}
              onChange={(e) => {
                setDiscountCode(e.target.value);
              }}
            />
            <button className="btn" onClick={applyDiscountCode}>
              Apply
            </button>
          </div>
          {updatedPromoCode || cart.is_applied_code ? (
            <p style={{color: 'green', marginBottom: '10px'}}>Code applied</p>
          ) : updatedPromoCode === false ? (
            <p style={{color: 'red', marginBottom: '10px'}}>Invalid code</p>
          ) : null}
        </div>}

        <div>
          <div>
            <div className="cart-page__subtotal">
              <p>Subtotal (Ex. GST)</p>
              {cart.is_applied_code ? (
                <p>{cart.discounted_items_total}</p>
              ) : (
                <p>{cart.items_total}</p>
              )}
            </div>
          </div>

          <div className="cart-page__borderless-row">
            <div>
              <div className="header-cart-popup__btns cart-page__continue">
                <a
                  href={cart.checkout_link}
                  className={`btn btn--black btn--not-bg-icon ${cartUpdating ? 'btn--disabled' : ''}`}
                >
                  {cartUpdating && <Loading/>}
                  {!cartUpdating && <>
                    <span>Continue</span>
                    <CaretRight/>
                  </>}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
};

export default CartPage;
